import { NewsletterListIds } from './newsletter-list-ids.ts';
import type { AppConfig } from './types.ts';

export const ProductionConfig: AppConfig = Object.freeze({
	TimeDomain: 'https://time.heni.com',
	MetaPixelId: 3261122710819288,
	TurnstileKey: '0x4AAAAAAA1n2oTsw__Xxap6',
	GoogleMapsEmbedKey: 'AIzaSyANAggCjP6-YxvGSV0hB5vHgxLKqPWNwnE',
	NewsletterListIds: NewsletterListIds,
	PolicyName: '',
	RecaptchaKey: '6LeKlgsjAAAAAKWBPcxiKIjAF6HO65rHadG-kjVl',
	GraphqlApiKey: 'ZKJGXoZcEMUIEN1wWffNB-3YxAh8fBz4',
	GraphqlApiDomain: 'https://api.heni.com',
	MutationsGraphqlApiUrl: 'https://api.heni.com/heni/graphql',
	ClientContextKey:
		'1ddf75b454a4f583dfba09a10fbf09e60571a1b6871ed8ba7145dfaf20ed97ea',
	GraphqlApiUrl: 'https://api.heni.com/graphql',
	WebsiteApiUrl: 'https://api.heni.com',
	FingerprintApiKey: 'yFbv6407iinWUb7wFQEw',
	Domain: 'https://heni.com',
	AuthDomain: '',
	Stripe:
		'pk_live_51H3O9zJGrlksuslkcYz6sCbNGPvTfdf4L5IHPvOSAxmjnL68xnAJ7YikK2OuApsYhbb8IYPaBeKAJre2nEQoJc8K00aaktM1IS',
	StripeUs:
		'pk_live_51J4oHoKrbYNeKR84PHyt6p55ccKkxCtW5hH2EyiZmWY9JAi1ToQruFKunSUPwPxYf412VlHAPTwQrO5FCSWRakK700hyYyEVW7',
});
